<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" @click="$emit('click')">
        <title>Close</title>
        <rect x="-18.28" y="44.12" width="136.55" height="11.75" rx="5.88" ry="5.88" transform="translate(-20.71 50) rotate(-45)"/>
        <rect x="-18.28" y="44.12" width="136.55" height="11.75" rx="5.88" ry="5.88" transform="translate(50 120.71) rotate(-135)"/>
    </svg>
</template>

<script>
    export default { name: "CloseIcon" }
</script>